import { createContext, useState } from 'react';

interface IColRowHighlighting {
  colHighlightIndex: number;
  setColHighlightIndex: (idx: number) => void;
  rowHighlightIndex: number;
  setRowHighlightIndex: (idx: number) => void;
}

interface IColRowHighlightingProvider {
  children: React.ReactNode;
}

const ColRowHighlightContext = createContext<IColRowHighlighting>({
  colHighlightIndex: -1,
  setColHighlightIndex: () => null,
  rowHighlightIndex: -1,
  setRowHighlightIndex: () => null,
});

const ColRowHighlightingProvider = ({ children }: IColRowHighlightingProvider) => {
  const [colHighlightIndex, setColHighlightIndex] = useState(-1);
  const [rowHighlightIndex, setRowHighlightIndex] = useState(-1);

  return (
    <ColRowHighlightContext.Provider
      value={{
        colHighlightIndex,
        setColHighlightIndex,
        rowHighlightIndex,
        setRowHighlightIndex,
      }}
    >
      {children}
    </ColRowHighlightContext.Provider>
  );
};

export { ColRowHighlightContext, ColRowHighlightingProvider };
